import React, { useState, useEffect } from 'react';

import { makeStyles, Container, Grid, Paper, IconButton } from '@material-ui/core';
import BreadCrumb from 'app/components/BreadCrumb';
import CustomPaginationActionsTable from 'app/components/TableList/TableList';
import { injectIntl } from 'react-intl';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import { useDispatch, useSelector } from 'react-redux';
import { errorHandler } from 'app/utils/errorHandler';
import { fetchLicenses } from 'app/store/slices/company';

import styles from './styles';
import ModalDocuments from 'app/components/ModalDocuments';
import moment from 'moment';
const useStyles = makeStyles(styles);

const LinkDocumento = ({ classes, content, openModal }) => {
  const handleClick = () => {
    openModal(content);
  };

  if (!content.documentos || content.documentos.length === 0) return <></>;
  return (
    <>
      <IconButton
        color="primary"
        className={classes.iconDocument}
        size="small"
        onClick={() => handleClick()}
      >
        <InsertDriveFileIcon className={classes.icon} />
      </IconButton>
    </>
  );
};

function LicensesList(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState({});

  const [open, setOpen] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState({});

  const prepareData = content => {
    return {
      originalData: content,
      num_licenca: <>{content.nuLicencaFmt}</>,
      placa: <>{content.dePlaca}</>,
      tipo_licenca: <>{content.nmServico}</>,
      data_vencimento: <>{moment.utc(content.dtVencimento).format("DD/MM/YYYY")}</>,
      document: (
        <LinkDocumento {...props} classes={classes} content={content} openModal={openModal} />
      ),
    };
  };

  const openModal = item => {
    setSelectedLicense(item);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedLicense({});
    setOpen(false);
  };

  const licenses = useSelector(state => state.company.licenses);

  const { intl } = props;

  useEffect(() => {
    setLoading(true);
    const findRequests = async () => {
      try {
        const search = { page: page, size: pageSize, request: { ...filters } };
        await dispatch(fetchLicenses(search));
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    };
    findRequests();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, filters, page, pageSize]);

  useEffect(() => {
    const rows = [];
    if (licenses.content) {
      licenses.content.forEach(cont => {
        rows.push(prepareData(cont));
      });
    }
    setRows(rows);
    setPagination(licenses);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [licenses]);

  const handleChangeFilter = (key, value) => {
    const temp = { ...filters };
    temp[key] = value;
    setFilters(temp);
  };

  const onChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const onChangeRowsPerPage = event => {
    setPageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onBlurSearch = event => {
    handleChangeFilter('txtBusca', event.target.value);
    setPage(0);
  };

  const handleClickRow = (e, row) => {};

  const onChangeSearch = event => {};

  const columns = [
    // { title: 'N. de Licença', field: 'num_licenca', align: 'left' },
    { title: 'Placa', field: 'placa', align: 'left' },
    { title: 'Tipo de Licença', field: 'tipo_licenca', align: 'left' },
    { title: 'Vencimento Licença', field: 'data_vencimento', align: 'left' },
    { title: '', field: 'document', align: 'left' },
  ];

  const breadCrumb = [
    {
      title: intl.formatMessage({ id: 'LABELS.LICENSES.LICENSES' }),
      path: '',
    },
  ];

  return (
    <>
      <ModalDocuments
        title={`Documentos`}
        type="licencas"
        open={open}
        onClose={handleClose}
        data={selectedLicense}
      />
      <Container>
        <BreadCrumb breadCrumb={breadCrumb} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.container} elevation={3}>
              <CustomPaginationActionsTable
                loading={loading}
                columns={columns}
                rows={rows}
                placeholderSearch="Busca"
                pagination={pagination}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                onBlurSearch={onBlurSearch}
                onChangeSearch={onChangeSearch}
                onClickRow={handleClickRow}
                hideOrder={true}
                hideItemOrder={true}
                hideInitialDate={true}
                hideFinalDate={true}
              />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default injectIntl(LicensesList);
